import React from "react";
import {List} from ".."

const HeaderStatusIndicators = ({ renderItem, data }) => {
    return renderItem(data)
}
 
export default HeaderStatusIndicators;